module.exports = __webpack_public_path__ + "img/vw_skeeball_dark-overlay.47513960.jpg";